import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {buildQuery} from "utils/uri";
import {OrganisationId} from "common/types/organisation";
import {ProjectId} from "common/types/project";
import {DocumentId} from "common/types/document";
import {WorkflowId, WorkflowInstanceId} from "common/flowmaster/types/workflow";
import {DataAssetRunInfo} from "common/flowmaster/types/data_asset";
import {LlmRunId} from "common/flowmaster/types/llm_run";

export type DataAssetConfigRunsFetchAction = {
  type: WorkflowsActionTypes["DATA_ASSET_CONFIG_RUNS_FETCH"]["SUCCESS"];
  payload: DataAssetRunInfo[];
  action: (
    organisationId: OrganisationId,
    projectId: ProjectId | null,
    documentId: DocumentId | null,
    definitionId: WorkflowId,
    configId: WorkflowInstanceId,
    from: string,
    to: string,
    fetchGroupRuns: boolean,
    runId: LlmRunId | null,
    maxRuns: number,
  ) => DataAssetRunInfo[];
};

export default function fetchDataAssetConfigRuns(requestor) {
  return createReduxPromiseAction(
    ActionTypes.DATA_ASSET_CONFIG_RUNS_FETCH,
    (
      organisationId,
      projectId,
      documentId,
      definitionId,
      configId,
      from,
      to,
      fetchGroupRuns,
      runId,
      maxRuns,
    ) =>
      requestor
        .get(
          `${basePath}/organisation/${organisationId}/llm_run/data_asset` +
            `/definition/${definitionId}` +
            `/config/${configId}{${buildQuery({
              ...(Boolean(projectId) && {project: projectId}),
              ...(Boolean(documentId) && {document: documentId}),
              ...(Boolean(from) && {from}),
              ...(Boolean(to) && {to}),
              ...(Boolean(fetchGroupRuns) && {fetchGroupRuns}),
              ...(Boolean(runId) && {runId}),
              ...(Boolean(maxRuns) && {limit: maxRuns}),
            })}`,
          {withCredentials: true},
        )
        .then(response => response.data),
  );
}
